module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/error-631f08dfacc38cef6c6964112fb9b74f.svg";